import type { ComponentPropsWithoutRef } from "react";
import { t } from "@/i18n-js/instance";
import { BROADCAST_PERSONALIZATION_VARIABLES } from "@/react/components/SettingsApp/Emails/components/Broadcasts/constants";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { InsertVariableButtonWrapper } from "@circle-react-uikit/InsertVariableButton/InsertVariableButtonWrapper";

interface MenuBarVariableButtonProps
  extends Omit<
    ComponentPropsWithoutRef<typeof InsertVariableButtonWrapper>,
    "children" | "variables"
  > {
  isActive?: boolean;
}

export const MenuBarVariableButton = (props: MenuBarVariableButtonProps) => (
  <InsertVariableButtonWrapper
    {...props}
    variables={BROADCAST_PERSONALIZATION_VARIABLES}
    wrapperClassName=""
    optionsClassName="z-10 !w-60 right-0"
    shouldRenderPortal
  >
    <TippyV2 delay={300} content={t("tiptap.add_variable")} interactive={false}>
      <div className="hover:bg-secondary flex size-6 items-center justify-center rounded border border-transparent">
        <Icon
          type="16-brackets-2"
          size={14}
          style={{ "--icon-width": "14px" }}
        />
      </div>
    </TippyV2>
  </InsertVariableButtonWrapper>
);
